const isTruthy = (value: string | boolean | undefined): boolean => {
  if (typeof value === 'boolean') {
    return value
  }
  return value === 'true'
}

export const featureFlags = {
  experimentalAgentMenu: isTruthy(import.meta.env.VITE_ENABLE_EXPERIMENTAL_AGENT_MENU),
  objectViewV1: isTruthy(import.meta.env.VITE_FF_OBJECT_VIEW_V1),
  actionPanelV1: isTruthy(import.meta.env.VITE_FF_ACTION_PANEL_V1),
  agentConsoleV1: isTruthy(import.meta.env.VITE_FF_AGENT_CONSOLE_V1),
  /**
   * Phase 1 / Org Introduction (P6): gates the Organization UI surface.
   *
   * - OrgSwitcher rendering in {Marketing,}TopNav
   * - ``/welcome`` onboarding (org claim flow)
   * - ``/orgs/:slug/settings`` organization settings
   * - ``/projects/all`` cross-org project picker
   * - ``CreateProjectDialog`` organization selector (off ⇒ personal-org auto fallback)
   *
   * Backend APIs remain functional regardless — this flag only controls UI
   * gating so the Phase 1 rollout can stage cohorts. Default off; flip to
   * true in ``.env`` (``VITE_ORG_UI_ENABLED=true``) when the cohort is ready.
   */
  orgUiEnabled: isTruthy(import.meta.env.VITE_ORG_UI_ENABLED),
}
